// TEMPLATE - copy to src/firebase/config.js and modify accordingly

import { initializeApp } from 'firebase/app';
import {
  getFirestore,
  //connectFirestoreEmulator // COMMENT TO DEPLOY
} from 'firebase/firestore';
import {
  getAuth,
  //connectAuthEmulator // COMMENT TO DEPLOY
} from 'firebase/auth';

// init firebase - Copy the values from the Project Settings page on the Firebase project's console (and create WEB app with firebase hosting, if not done yet)
initializeApp({
  apiKey: "AIzaSyBdSv02S_ikeOJ6VefH2vGf5InqtSyHW8w",
  authDomain: "heylight-visioni.firebaseapp.com",
  projectId: "heylight-visioni",
  storageBucket: "heylight-visioni.firebasestorage.app",
  messagingSenderId: "943678631016",
  appId: "1:943678631016:web:afd221a09b5f47407adfdd",
  measurementId: "G-M08ZDDNXEC"
});
// init services
const db = getFirestore();
const auth = getAuth();

// use emulator -- COMMENT TO DEPLOY
//connectFirestoreEmulator(db, 'holipay.visioni.io', 8080);
//connectAuthEmulator(auth, 'http://holipay.visioni.io:9099');

export { db, auth }
